
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jpg-to-jpeg-converter",
      function () {
        return require("private-next-pages/jpg-to-jpeg-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jpg-to-jpeg-converter"])
      });
    }
  